import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Label from '../label/label';

const RadioButtonStyled = styled.div`
  ${({ useDefaultTheme }) => {
    return css`
      ${useDefaultTheme &&
        css`
          .radio-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            input {
              height: auto;
              width: auto;
              margin: 0 4px 0 0;
            }
            label {
              display: inline-block;
            }
          }
        `}
    `;
  }};
`;

const RadioButton = ({
  className,
  formId,
  setValue,
  id,
  type,
  label,
  validations,
  defaultLanguage,
  useDefaultTheme,
}) => {
  if (!validations) return null;
  const isRequired = validations && validations.required ? true : false;
  const cbValues =
    validations &&
    validations.allowedValues &&
    validations.allowedValues.values;

  if (!cbValues || cbValues.length < 1) return null;
  return (
    <RadioButtonStyled
      className="radio-container"
      useDefaultTheme={useDefaultTheme}
    >
      <Label
        id={id}
        label={label}
        isRequired={isRequired}
        className="label-radio-container"
      />
      {cbValues.map((val, idx) => {
        return (
          <span key={idx} className="radio-wrapper">
            <input
              type={type}
              id={val[defaultLanguage]}
              name={id}
              value={val[defaultLanguage]}
              className={`${className ? className : ''} input-radio`}
              onChange={e => {
                setValue(formId, id, e.target.value);
              }}
            />
            <label
              className="label-radio"
              id={val[defaultLanguage]}
              htmlFor={val[defaultLanguage]}
            >
              {val[defaultLanguage]}
            </label>
          </span>
        );
      })}
    </RadioButtonStyled>
  );
};

RadioButton.propTypes = {
  className: PropTypes.string,
  formId: PropTypes.string,
  setValue: PropTypes.func,
  id: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  validations: PropTypes.object,
  defaultLanguage: PropTypes.string,
  useDefaultTheme: PropTypes.bool,
};

export default RadioButton;
